var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "modal-detail",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_vm.currentDetailId ? _c('div', {
          staticClass: "p-2 products__detail",
          style: _vm.colorObject
        }, [_c('button', {
          staticClass: "products__detail__close",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("./images/close.svg")
          }
        })]), _c('div', {
          staticClass: "products__detail__hero"
        }, [_c('img', {
          staticClass: "products__detail__hero__img",
          attrs: {
            "src": _vm.currentDetail.image
          }
        }), _c('div', {
          staticClass: "products__detail__hero__title mt-2"
        }, [_vm._v(" " + _vm._s(_vm.currentDetail.title) + " ")]), _c('div', {
          staticClass: "products__detail__description mt-2",
          domProps: {
            "innerHTML": _vm._s(_vm.currentDetail.description)
          }
        })])]) : _vm._e()];
      }
    }])
  }), _vm.deepGet(_vm.preorderSetting, 'config.product_page.enable_filters', false) ? _c('div', {
    staticClass: "d-flex align-items-center p-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query.category,
      expression: "query.category"
    }],
    staticClass: "form-control select-category mr-2",
    on: {
      "input": _vm.handleCategoryIsChanged,
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.query, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.formattedCategories, function (category, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": category.value
      }
    }, [_vm._v(_vm._s(category.label) + " ")]);
  }), 0), _c('button', {
    staticClass: "p-2 btn",
    on: {
      "click": function click($event) {
        _vm.isSearching = !_vm.isSearching;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-search.svg")
    }
  })]), _vm.isSearching ? _c('div', {
    staticClass: "search px-3 py-2 d-flex align-items-center shadow shadow-sm"
  }, [_c('form', {
    staticClass: "search-box p-2 px-3 flex-fill d-flex align-items-center",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSearchIsSubmitted.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "icon mr-2",
    attrs: {
      "src": require("./images/icon-search.svg")
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query.keyword,
      expression: "query.keyword"
    }],
    staticClass: "box",
    attrs: {
      "type": "text",
      "placeholder": "搜尋",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.query.keyword
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.query, "keyword", $event.target.value);
      }
    }
  }), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })]), _c('button', {
    staticClass: "btn text-black text-nowrap font-weight-bolder",
    on: {
      "click": _vm.handleSearchIsSubmitted
    }
  }, [_vm._v(" 送出 ")]), _c('button', {
    staticClass: "btn text-black text-nowrap font-weight-bolder",
    on: {
      "click": function click($event) {
        _vm.isSearching = !_vm.isSearching;
      }
    }
  }, [_vm._v(" 取消 ")])]) : _vm._e()]) : _vm._e(), _c('div', {
    staticStyle: {
      "flex": "1 1 auto",
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFetchingPreorder,
      expression: "isFetchingPreorder"
    }],
    staticClass: "spinner-positioner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  })], 1), _c('div', {
    staticClass: "products",
    class: _vm.currentView
  }, _vm._l(_vm.formattedSkus, function (sku) {
    return _c('div', {
      key: sku.id,
      staticClass: "products__item"
    }, [_c('div', {
      staticClass: "products__item__photo"
    }, [sku.image ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": sku.image
      }
    }) : _vm._e(), _vm.deepGet(_vm.preorderSetting, 'config.product_page.display_detail') ? _c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-detail",
        modifiers: {
          "modal-detail": true
        }
      }],
      staticClass: "btn products__item__photo__detail",
      on: {
        "click": function click($event) {
          _vm.currentDetailId = sku.id;
        }
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
      }
    })])]) : _vm._e()]), _c('div', {
      staticClass: "products__item__title product__title"
    }, [_vm._v(_vm._s(sku.title))]), _vm.priceIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [sku.is_discounted ? [_c('span', {
      staticClass: "promoting"
    }, [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(sku.discounted_price)))]), _c('span', {
      staticClass: "original-price ml-2"
    }, [_vm._v("$ " + _vm._s(_vm.applyThousandsSeperator(sku.original_price)))])] : _c('div', [_vm._v("$" + _vm._s(_vm.applyThousandsSeperator(sku.original_price)))])], 2) : _vm._e(), _vm.pointIsVisible ? _c('div', {
      staticClass: "products__item__price"
    }, [_vm._v(_vm._s(sku.point) + " 點")]) : _vm._e(), _c('div', {
      staticClass: "products__item__description",
      domProps: {
        "innerHTML": _vm._s(sku.description)
      }
    }), _c('div', {
      staticClass: "products__item__add-to-cart"
    }, [_c('b-form-spinbutton', {
      staticClass: "text-center px-0",
      class: {
        'increment-disabled': _vm.cannotAddMoreQuantity(sku)
      },
      staticStyle: {
        "border-radius": "0.5rem"
      },
      attrs: {
        "min": "0",
        "value": _vm.findSkuQuantityInCart(sku.id)
      },
      on: {
        "change": function change(quantity) {
          return _vm.handleSkuQuantityChange(sku.id, quantity);
        }
      }
    })], 1)]);
  }), 0)]), _c('Pagination', {
    staticClass: "my-3",
    attrs: {
      "current": _vm.query.page,
      "total-page": _vm.lastPage
    },
    on: {
      "input": _vm.handlePageIsChanged
    },
    model: {
      value: _vm.query.page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "page", $$v);
      },
      expression: "query.page"
    }
  }), _c('footer', {
    staticClass: "sticky-bottom footer-action-bar mt-auto"
  }, [_c('div', {
    staticClass: "footer-action-bar__summary",
    class: {
      'justify-content-center': !_vm.priceIsVisible && !_vm.pointIsVisible
    }
  }, [_c('div', {
    staticClass: "footer-action-bar__statistic"
  }, [_c('img', {
    staticClass: "footer-action-bar__cart-icon mr-1",
    attrs: {
      "src": require("./images/icon-cart.svg")
    }
  }), _c('span', {
    staticClass: "footer-action-bar__total-quantity"
  }, [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm.priceIsVisible ? _c('div', {
    staticClass: "footer-action-bar__statistic"
  }, [_vm._v(" $ "), _c('span', {
    staticClass: "footer-action-bar__total-price"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPrice)) + " ")])]) : _vm._e(), _vm.pointIsVisible ? _c('div', {
    staticClass: "footer-action-bar__statistic"
  }, [_c('span', {
    staticClass: "footer-action-bar__total-price mr-2"
  }, [_vm._v(" " + _vm._s(_vm.applyThousandsSeperator(_vm.totalPoints)) + " ")]), _vm._v(" 點 ")]) : _vm._e()]), _c('ShareButton', {
    staticClass: "footer-action-bar__checkout-button",
    attrs: {
      "disabled": _vm.totalQuantity === 0 || _vm.isPointMode && _vm.totalPoints > _vm.memberPoints
    },
    on: {
      "click": _vm.handleNextStepButtonClicked
    }
  }, [_vm._v(" 下一步 ")])], 1), _c('b-modal', {
    ref: "popupReachedQuantityLimit",
    staticClass: "modal",
    attrs: {
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var close = _ref2.close;
        return [_c('button', {
          staticClass: "modal__close",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/pages/Liff/Badge/images/close.svg")
          }
        })]), _c('div', {
          staticClass: "p-2"
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(_vm.preorderSetting, 'config.status_limit.warning') || '已達預購單數量上限'))])])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }